// extracted by mini-css-extract-plugin
export default {"zr-checkbox":"Checkbox_zr-checkbox__E6cYh","checkmark":"Checkbox_checkmark__kBrF0","zr-checkbox-tree":"Checkbox_zr-checkbox-tree__+fHcU","label-text":"Checkbox_label-text__fWrPd"};